const BASE = 'https://northbridgeautosolutions.ie/srvr/api';

function getToken() { return localStorage.getItem('nb_admin_token'); }

async function req(path, opts = {}) {
  const token = getToken();
  const res = await fetch(`${BASE}${path}`, {
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...opts.headers,
    },
    ...opts,
    body: opts.body ? JSON.stringify(opts.body) : undefined,
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Request failed');
  return data;
}

export const api = {
  // Listings (public)
  getListings: (params = {}) => {
    const qs = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => {
      if (Array.isArray(v)) v.forEach(val => qs.append(k, val));
      else if (v !== undefined && v !== '') qs.append(k, v);
    });
    return req(`/listings?${qs}`);
  },
  getListing:  (id) => req(`/listings/${id}`),
  getStats:    ()   => req('/listings/stats'),
  getMakes:    ()   => req('/makes'),

  // Listings (admin)
  createListing: (body) => req('/listings', { method: 'POST', body }),
  updateListing: (id, body) => req(`/listings/${id}`, { method: 'PUT', body }),
  deleteListing: (id) => req(`/listings/${id}`, { method: 'DELETE' }),

  // Enquiries
  sendEnquiry:    (body) => req('/enquiries', { method: 'POST', body }),
  getEnquiries:   ()     => req('/enquiries'),
  markEnquiryRead:(id)   => req(`/enquiries/${id}/read`, { method: 'PUT' }),
  deleteEnquiry:  (id)   => req(`/enquiries/${id}`, { method: 'DELETE' }),

  // Import requests
  sendImportRequest:   (body) => req('/import-requests', { method: 'POST', body }),
  getImportRequests:   ()     => req('/import-requests'),
  updateImportRequest: (id, body) => req(`/import-requests/${id}`, { method: 'PUT', body }),
  deleteImportRequest: (id)   => req(`/import-requests/${id}`, { method: 'DELETE' }),

  // Admin auth
  adminLogin:  (body) => req('/admin/login', { method: 'POST', body }),
  adminVerify: ()     => req('/admin/verify'),
};
